import { useState } from 'react';
import { Switch } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { PatchTypeData } from '@/types/bundles-upcharges.types';
import { CustomTableMeta } from '../Tables/TableCard/TableCard.types';

export const SwitchCell = ({ row, table }: CellContext<PatchTypeData, unknown>) => {
  const { original } = row;
  const { isVisible, ...rest } = original;
  const { updateData } = table.options.meta as CustomTableMeta<PatchTypeData>;
  const [checked, setChecked] = useState(isVisible === 'Yes');

  const handleClick = () => {
    const saveIsLock = !checked;
    setChecked((prevState) => !prevState);
    updateData(row.index, 'isVisible', `${saveIsLock}`);
  };

  return <Switch color="error" size="small" title="switch" checked={checked} onClick={() => handleClick()} {...rest} />;
};
